import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography } from "@mui/material";
import { setDefaultAddress } from "../../../actions";
import AddOrEditAddress from "../../Shared/AddOrEditAddress";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";



const AddNewAddressButton = styled.button`
width: 200px;
height: 85px;
margin-left: 1rem;
font-family: "Ancizar Sans", sans-serif;
border: 1px solid #ccc;
border-radius: 4px;
color: #333;
font-size: 16px;
cursor: pointer;



`
const SelectAddressBox = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
min-height: 50px;
width: 200px;
margin-left: 1rem;
margin-bottom: 1rem;
padding: .5rem .5rem;
border: 1px solid rgba(0, 0, 0, 0.12);
border-radius: 8px;
cursor: pointer;
`

const AddressLine1 = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
width: 100%;
d

`

const SelectAddressNumber = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
width: 100%;

font-size: 0.9rem;
font-family: Ancizar Sans;
border-radius: 8px;
`

const FullName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  font-size: 0.9rem;
  font-family: Ancizar Sans;
  border-radius: 8px;
`;

const CheckoutAddressGroupNew = (props) => {
  const { stepAction = () => {} } = props;
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const selectedAddress = useSelector(
    (state) => state.userDetails?.defaultAddress || {}
  );
  const { contactDetailId = "" } = selectedAddress;
  const userProfile = useSelector(
    (state) => state.userDetails?.userProfile || {}
  );
  const { contactDetails = [] } = userProfile;
  const [selectedAddressIdx, setSelectedAddressIdx] =
    React.useState(contactDetailId);
  const [sortContactAddress, setSortContactAddress] = React.useState([]);
  const [noAddressList, setNoAddressList] = React.useState(false);
  const [enableAddAddress, setEnableAddAddress] = React.useState(false);
  

  const selectedAdresss = (event) => {
    setSelectedAddressIdx(event.target.value);
    const getChangeAddress = contactDetails?.find(
      (Item) => Item.contactDetailId === event.target.value
    );
    dispatch(setDefaultAddress(getChangeAddress));
  };

  React.useEffect(() => {
    if (contactDetails?.length) {
      setNoAddressList(false);
      let sortedList = contactDetails.reduce((prev, curr) => {
        let obj = { ...curr };
        let selectedAdd =
          curr.contactDetailId === contactDetailId ? curr.contactDetailId : "";
        if (selectedAdd) {
          prev.unshift(obj);
        } else {
          prev.push(obj);
        }
        return prev;
      }, []);
      setSortContactAddress(sortedList);
    } else {
      setNoAddressList(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactDetails]);

  const addNewAddressClick = () => {
    setEnableAddAddress(true);
    navigate('/account?AM=address')
  };

  const disableAddAddress = () => {
    setEnableAddAddress(false);
  };

  return (
    <>
      {!noAddressList ? (
       <>
          
          {sortContactAddress?.length > 0 && sortContactAddress.map(
            (element, index) => {


              console.log("element", element);
            
              return(

             <> 
             
             
               <SelectAddressBox>
               <SelectAddressNumber>
                {element?.phoneNo}
               </SelectAddressNumber>
               <AddressLine1>
                {element?.address?.addressLine1},{element?.address?.addressLine2},
               </AddressLine1>
                <FullName>
                  {element?.fullName}
               </FullName>
               </SelectAddressBox>
                </>
              )


            })}
               <AddNewAddressButton onClick={addNewAddressClick}>
        Add New Address
       </AddNewAddressButton>
          
        </>
      ) : (
       <AddNewAddressButton onClick={()=>{navigate('/account?AM=address')}}>
        Add New Address
       </AddNewAddressButton>
      )}
    </>
  );
};
export default CheckoutAddressGroupNew;

const FormControlLabelContainer = (props) => {
  const { stepAction, element, selectedAddressIdx } = props;
  const { fullName = "", phoneNo = "", address = {}, userId = "" } = element;
  const {
    addressLine1 = "",
    addressLine2 = "",
    city = "",
    state = "",
    pinCode = "",
  } = address;

  const EditAddressPlayload = {
    fullName,
    phoneNo,
    address,
    contactDetailId: selectedAddressIdx,
    userId,
  };

  // const [editDeliveryAddress, setEditDeliveryAddress] = React.useState();
  const [enableEditAddress, setEnableEditAddress] = React.useState(false);

  const handleEditDeliveryAddress = () => {
    setEnableEditAddress(true);
  };

  const handleCancelEditAddress = () => {
    setEnableEditAddress(false);
  };

  React.useEffect(() => {
    setEnableEditAddress(false);
  }, []);

  return (
    <Grid container spacing={2} direction={"row"}>
      {!enableEditAddress && (
        <Grid xs={11} md={11}>
          <FormControlLabel
            value={element?.contactDetailId}
            control={<Radio />}
            label={
              <>
                <Grid
                  container
                  spacing={2}
                  direction={"column"}
                  sx={{ p: 0, m: 0 }}
                  rowSpacing={1}
                >
                  <Grid>
                    <Typography
                      variant="body"
                      component="div"
                      color="black"
                      fontWeight={"bold"}
                    >
                      {`${fullName}, ${phoneNo}`}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      variant="body"
                      component="div"
                      color="text.secondary"
                      fontWeight={500}
                    >
                      {`${addressLine1}, ${
                        addressLine2 && addressLine2
                      }, ${city}, ${state}, ${pinCode}`}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            }
            sx={{ pb: 1 }}
          />
          {selectedAddressIdx === element.contactDetailId &&
            !enableEditAddress && (
              <Grid sx={{ pl: 5 }}>
                <Button
                  variant="contained"
                  color="buynow"
                  sx={{ color: "white", mb: 2 }}
                  onClick={() => stepAction(3)}
                >
                  Deliver here
                </Button>
              </Grid>
            )}
        </Grid>
      )}
      <Grid xs={1} md={1}>
        {selectedAddressIdx === element.contactDetailId &&
          !enableEditAddress && (
            <Button onClick={handleEditDeliveryAddress}>Edit</Button>
          )}
      </Grid>
      {enableEditAddress && (
        <Grid xs={12} md={12}>
          <FormControlLabel
            value={"Edit Address"}
            control={<Radio checked />}
            label={
              <>
                <Grid xs={11} md={11}>
                  <AddOrEditAddress
                    action="edit"
                    editAddressDetails={EditAddressPlayload}
                    cancelEditAddress={handleCancelEditAddress}
                  />
                </Grid>
              </>
            }
          />
        </Grid>
      )}
    </Grid>
  );
};
